export default __webpack_public_path__ + "static/media/tennis-platinum-featured.521a79e5.png";